import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {AudioDescriptionSearchParams} from '../../audio-description-search-params';
import {AudioDescription} from '../../audio-description';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-audio-description-list',
  templateUrl: './audio-description-list.component.html',
  styleUrls: []
})
export class AudioDescriptionListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new AudioDescriptionSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/audio-description', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: AudioDescription) {
    this.router.navigateByUrl(`/audio-description/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/audio-description/create']);
  }
}
